module.exports = __webpack_public_path__ + "a84d93449dcd9c4a383c5d926af04e3a.otf";